import React from 'react';
import Link from 'gatsby-link';
import BackToTop from '../components/BackToTop';
import Menu from '../components/Menu';
import Form from '../components/form';
import kitchenimg from '../static/images/pc/kitchen.jpg';
import timeIcon from '../static/images/icon/time.svg';
import frypanIcon from '../static/images/icon/frypan.svg';
import ovenIcon from '../static/images/icon/oven.svg';
import potIcon from '../static/images/icon/pot.svg';
import wifiIcon from '../static/images/icon/wifi.svg';
import coffeeIcon from '../static/images/icon/coffee.svg';
import fridgeIcon from '../static/images/icon/fridge.svg';
import toastIcon from '../static/images/icon/toast.svg';
import dishToolIcon from '../static/images/icon/dish_tool.svg';
import seasoningIcon from '../static/images/icon/seasoning.svg';
import printerIcon from '../static/images/icon/printer.svg';

export default function Kitchen() {
  return (
    <main>
      <Menu />
      <div className="p-container">
        <div className="p-content -border-top">
          <h2 className="p-detail-header">KITCHEN</h2>
        </div>
      </div>

      <div className="p-container -border-left">
        <div className="p-detail-lead">
          「ワイワイ」な1F。<br />
          居間のように使える、<br className="p-sp-content" />
          会員制キッチンを使いこなそう。
        </div>
      </div>

      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-description">
            コトイロの1Fはグルメなあなたにはたまらない大きめなキッチン。レイアウト変更自由なダイニングを使いこなせば、あなたにとっての第2のキッチンができたようなもの。
          </div>
        </div>
      </div>

      <div className="p-detail-images">
        <img src={kitchenimg} alt="" className="p-detail-image" />
      </div>

      <h3 className="p-detail-sub-header">HOW TO USE & FACILITIES</h3>

      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-description">
            みんなでワイワイごはんを食べたり、会社帰りに立ち寄ったり、時にはグルメイベントを開催したり。<br />それぞれの使い方で、みんなの居場所をつくりましょう。
          </div>
        </div>
      </div>

      <h4 className="p-detail-spec-header">利用可能時間帯</h4>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-spec">
            <img src={timeIcon} alt="" />
            9:30-21:30
          </div>
        </div>
      </div>

      <h4 className="p-detail-spec-header">月額会費</h4>

      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-spec is-caption">￥1,000(2TICKET)</div>
          <div className="p-detail-caption">
            会員は1回の利用（最大3時間まで）につき、1チケットで利用できます。<br />
            1チケットで1名利用可能です。<br />
            ※別途入会金あり（1ヶ月分、2チケットつき）
          </div>
        </div>
      </div>

      <h4 className="p-detail-spec-header">お試し利用</h4>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-spec is-caption">￥1,000〜</div>
          <div className="p-detail-caption">1回最大3時間まで</div>
        </div>
      </div>

      <h4 className="p-detail-spec-header">貸切利用</h4>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-spec is-caption">1h / ￥3,000〜</div>
          <div className="p-detail-caption">
            2Fとの同時利用は ¥4,000<br />
            1日 (最大8時間)　¥20,000 ※2Fとの同時利用は¥24,000<br />
            6名以上同時利用の場合は貸切利用となります。<br />
            会員は下記の料金で貸切利用可能です（チケット払いOK）。<br />
            3時間 ￥5000- ※2Fとの同時利用は¥10,000-
          </div>
        </div>
      </div>

      <h4 className="p-detail-spec-header">その他料金</h4>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-spec -small">シェア調味料のご利用 ゴミ処理 / 各￥500</div>
          <div className="p-detail-caption">※ゴミお持ち帰りの際は無料です。 ※貸切利用のみ</div>
        </div>
      </div>

      <div className="p-detail-spec-header">無料サービス</div>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-services">
            <div>
              <div className="p-detail-services__icon">
                <img src={frypanIcon} alt="" />
              </div>
              <div className="p-detail-services__text">4口コンロ</div>
            </div>
            <div>
              <div className="p-detail-services__icon">
                <img src={ovenIcon} alt="" />
              </div>
              <div className="p-detail-services__text">オーブンレンジ</div>
            </div>
            <div>
              <div className="p-detail-services__icon">
                <img src={potIcon} alt="" />
              </div>
              <div className="p-detail-services__text">炊飯器</div>
            </div>
            <div>
              <div className="p-detail-services__icon">
                <img src={wifiIcon} alt="" />
              </div>
              <div className="p-detail-services__text">Wi-Fi</div>
            </div>
            <div>
              <div className="p-detail-services__icon">
                <img src={coffeeIcon} alt="" />
              </div>
              <div className="p-detail-services__text">コーヒーメーカー</div>
            </div>
            <div>
              <div className="p-detail-services__icon -fridge">
                <img src={fridgeIcon} alt="" />
              </div>
              <div className="p-detail-services__text">大型冷蔵庫</div>
            </div>
            <div>
              <div className="p-detail-services__icon">
                <img src={toastIcon} alt="" />
              </div>
              <div className="p-detail-services__text">ホットサンドメーカー</div>
            </div>
            <div>
              <div className="p-detail-services__icon -double">
                <img src={dishToolIcon} alt="" />
              </div>
              <div className="p-detail-services__text">調理用具 & 食器</div>
            </div>
          </div>
        </div>
      </div>

      <div className="p-detail-spec-header">有料サービス</div>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-services">
            <div>
              <div className="p-detail-services__icon -double">
                <img src={seasoningIcon} alt="" />
              </div>
              <div className="p-detail-services__text">シェア調味料<br />（貸切時のみ）</div>
            </div>
            <div className="-box-border-right">
              <div className="p-detail-services__icon">
                <img src={printerIcon} alt="" />
              </div>
              <div className="p-detail-services__text">プリンター</div>
            </div>
          </div>
        </div>
      </div>


      <div className="p-detail-spec-header">注意事項</div>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-caption">
            <ul>
              <li>キッチンは予約制です（予約必要なしのオープンデーあり。お問い合わせください）。</li>
              <li>利用説明を事前に受けて頂きます。</li>
              <li>初回ご利用時にチケットはお渡しします。</li>
              <li>チケットの有効期限は3か月です。</li>
              <li>法人ご利用の方、別料金になります。</li>
              <li>貸切イベント利用も可能です。ご相談ください。</li>
            </ul>
          </div>
        </div>
      </div>


      <h3 id="contact" className="p-detail-sub-header">RESERVATION</h3>
      <div className="p-container -border-left">
        <div className="p-content">
          <div className="p-detail-description">ご利用希望の方は、下記のフォームからお問い合わせください。</div>
        </div>
      </div>

      <div className="p-container -border-left p-pc-content">
        <div className="p-content">
          <div className="p-cal-container">
            <div className="p-cal">
              <iframe
                src="https://calendar.google.com/calendar/embed?showTitle=0&src=iwabuchi.cotoiro%40gmail.com&ctz=Asia%2FTokyo"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="p-cal p-sp-content">
        <iframe
          src="https://calendar.google.com/calendar/embed?showTitle=0&src=iwabuchi.cotoiro%40gmail.com&ctz=Asia%2FTokyo"
        />
      </div>

      <div className="p-container -border-left">
        <div className="p-content">
          <Form />
        </div>
      </div>

      <BackToTop classes="p-sp-content" />
    </main>
  );
}




// WEBPACK FOOTER //
// ./src/pages/kitchen.js